import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { homeRouteFor } from "../../access/core/routePolicies";
import { Button } from "../../components/ui";
import { Context } from "../../context/Context";
import "./NotFound.css";

const TEXT = {
  en: {
    title: "Page not found",
    body: "The link may be out of date, or the page may have moved.",
    home: "Back to home",
    dashboard: "Back to dashboard",
  },
  ar: {
    title: "الصفحة غير موجودة",
    body: "قد يكون الرابط قديماً أو قد تكون الصفحة نُقلت إلى مكان آخر.",
    home: "العودة إلى الرئيسية",
    dashboard: "العودة إلى لوحة التحكم",
  },
};

// Shown for a URL no route matches, inside or outside the /auth shell. A route the user may not
// open never reaches this page: its RouteGuard redirects first.
const NotFound = () => {
  const { lang, isAuthenticated, currentUserInfo } = useContext(Context);
  const navigate = useNavigate();
  const text = TEXT[lang] || TEXT.ar;
  const home = isAuthenticated ? homeRouteFor(currentUserInfo) : null;

  return (
    <main className="not-found-page" dir={lang === "en" ? "ltr" : "rtl"}>
      <p className="not-found-code" aria-hidden="true">404</p>
      <h1 className="not-found-title">{text.title}</h1>
      <p className="not-found-body">{text.body}</p>
      <Button variant="primary" appearance="filled" onClick={() => navigate(home || "/")}>
        {home ? text.dashboard : text.home}
      </Button>
    </main>
  );
};

export default NotFound;
